module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./meliaWidget.schema.json"));
	}, "validators");
}


//////////////////
// WEBPACK FOOTER
// ./src/widget/meliaWidget.schema.json
// module id = 240
// module chunks = 1